var map = {
	"./badges/jet.png": 1203,
	"./badges/rocket.png": 5168,
	"./badges/scientist.png": 9900,
	"./badges/teamplayer.png": 1180,
	"./cover1.jpg": 3269,
	"./cover2.jpg": 9130,
	"./cover3.jpg": 4935,
	"./cover4.jpg": 524
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6815;